import * as React from "react";
import { Icon, SmallIcon } from "@utdanningsdirektoratet/icon";
import { Input } from "@utdanningsdirektoratet/input";
import { isEmpty } from "@utdanningsdirektoratet/utils/string";
import { IconButton } from "@utdanningsdirektoratet/button";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./SearchInput.module.less";

type InputProps = React.ComponentProps<typeof Input>;
export interface SearchInputProps extends Omit<InputProps, "onChange" | "icon"> {
  onChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  disabled?: boolean;
  placeholder?: string;
  value?: string;
  icon?: SmallIcon | "none";
  withoutClear?: boolean;
}

const SearchInput = React.forwardRef<HTMLDivElement, SearchInputProps>(
  ({ icon = "search", className, placeholder = "Søk...", disabled, onChange, value = "", onClear, withoutClear, ...rest }, ref) => {
    const innerRef = React.useRef<HTMLInputElement>(null);
    const clearSearch = () => {
      onChange("");
      if (onClear) onClear();
      if (innerRef.current) innerRef.current.focus();
    };

    const searchClass = cls(
      {
        [styles.searchInput]: true,
      },
      className
    );

    const buttonClass = cls({
      [styles.searchInputButton]: true,
      [styles.searchInputButtonVisible]: !isEmpty(value) && !disabled,
    });

    const inputClass = cls({
      [styles.searchInputInput]: true,
      [styles.searchInputWithoutIcon]: !icon,
    });

    return (
      <div ref={ref} className={searchClass}>
        {icon && <Icon icon={icon} className={styles.searchInputIcon} />}
        <Input
          {...rest}
          ref={innerRef}
          value={value}
          placeholder={placeholder}
          onChange={(event) => onChange(event.target.value)}
          className={inputClass}
          disabled={disabled}
          icon="warning"
        />
        {!withoutClear && (
          <IconButton onClick={clearSearch} aria-label="Nullstill søk" className={buttonClass}>
            <Icon icon="cross" />
          </IconButton>
        )}
      </div>
    );
  }
);

export default SearchInput;
